import { render, staticRenderFns } from "./PersonnelRecordEditTabEmergencyContacts.vue?vue&type=template&id=4cec12b7"
import script from "./PersonnelRecordEditTabEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEditTabEmergencyContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports